import React from "react";
import { SFStack } from "../grid";
import { SFWarningIcon } from "../icons";
import { styled } from "@mui/material/styles";
import SFTypography from "../typography";
import { useTranslation } from "react-i18next";

const SFStackStyled = styled(SFStack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  padding: "12px",
  boxShadow: "none",
  borderRadius: "4px",
  border: `1px solid ${theme.palette.grey225.main}`,
  backgroundColor: theme.palette.grey50.main,
}));

const SFLoadingErrorCard = () => {
  const { t } = useTranslation();

  return (
    <SFStackStyled
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <SFWarningIcon rounded color="grey300"/>
      <SFTypography variant="body2">
        {t("components.loadingErrorCard.header")}
      </SFTypography>
    </SFStackStyled>
  );
};

export default SFLoadingErrorCard;
